<template>
<div id='navigation_header' class='top-navigation-container'>
    <DemoBanner v-if='show_demo_banner && !is_checkout && !is_outlet'/>
    <div class='header-bar'>
        <div class='nav-bar-items'>
            <div class='mobile-menu-container'>
                <MobileMenu v-show='!is_checkout && !is_outlet' :menu_items='menu_items' :headings='headings' :sub_headings='sub_headings'/>
            </div>
            <Logo :logged_in="logged_in"/>

            <div v-if='!logged_in'>
                <DesktopMenuBarTop :menu_items='menu_items' :headings='headings' :sub_headings='sub_headings'/>
            </div>
            
            <div v-show='!is_checkout && !is_outlet' class='right-container'>
                <Search v-show="logged_in"/>
                <!-- <div v-if="!logged_in" class='phone-icon' @click='headerClick("contact")'><i class="fa-solid fa-phone"></i></div>
                <button class='header-button login' @click='headerClick("login")'><i class="fa-regular fa-cart-shopping header-button-icon"></i> Login & Order</button>
                <button class='header-button'  @click='headerClick("new_customer")'><i class="fa-regular fa-arrow-right header-button-icon"></i>New Customer</button> -->
                <Account :logged_in="logged_in" :screen_width='screen_width'/>
                <Logout v-if="logged_in" @logoutListener="logoutListener" :screen_width='screen_width'/>
                <Basket v-if="logged_in" :updated_cart_watcher='updated_cart_watcher' @updatedCartListener='updatedCartListener'/>
            </div>
            <div v-show='is_outlet' class='right-container'>
                <Logout v-if="logged_in" @logoutListener="logoutListener" :screen_width='screen_width'/>
            </div>

        </div>
       
    </div>
    <DesktopMenuBar v-show='!is_checkout && !is_outlet && logged_in' :menu_items='menu_items' :headings='headings' :sub_headings='sub_headings' :logged_in="logged_in"/>
    <PrerenderedMenu v-show='!is_checkout && !is_outlet' :headings='headings'/>
</div>
</template>

<script>
import DesktopMenuBar from '@/ecom/components/navigation/header/menus/DesktopMenuBar.vue';
import DesktopMenuBarTop from '@/ecom/components/navigation/header/menus/DesktopMenuBarTop.vue';
import DemoBanner from '@/ecom/components/navigation/header/DemoBanner.vue';
import Search from '@/ecom/components/navigation/header/search/Search.vue';
import Basket from '@/ecom/components/navigation/header/basket/Basket.vue';
import Account from '@/ecom/components/navigation/header/Account.vue';
import Favourites from '@/ecom/components/navigation/header/Favourites.vue';
import Location from '@/ecom/components/navigation/header/Location.vue';
import Logo from '@/ecom/components/navigation/header/Logo.vue';
import MobileMenu from '@/ecom/components/navigation/header/menus/MobileMenu.vue';
import PrerenderedMenu from '@/ecom/components/navigation/header/menus/PrerenderedMenu.vue';
import Logout from '@/ecom/components/navigation/header/Logout.vue';

import {checkAuth} from "@/global/modules/functions.js";

export default {
    components: {DesktopMenuBar, DesktopMenuBarTop, Basket, Account, Logo, MobileMenu, Favourites, Location, DemoBanner, PrerenderedMenu, Search, Logout},
    props: ['updated_cart_watcher', 'is_logged_in', 'logged_in_watcher', 'is_checkout', 'is_outlet'],
    emits:['updatedCartListener'],
        data(){
            return{
                menu_items:[],
                headings: [],
                sub_headings:[],
                items: [],
                show_demo_banner: false,
                logged_in: false,
                screen_size_check_timeout: null,
                screen_width: 0
            }
        },
    methods:{
        async getMenuItems(){
            let response = await fetch(`/api/nav-bar/menu-items`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.logged_in = results.logged_in;
                this.menu_items = results.menu_items;
                this.formatMenuData();

                this.show_demo_banner = results.show_demo_banner;
                if(this.show_demo_banner){
                    document.querySelector(':root').style.setProperty('--demo-banner-message-height', '35px');
                }
            }
        },
        formatMenuData(){
            this.headings = this.menu_items.filter(x=>x.parent_id == 0);

            for (let i = 0; i < this.headings.length; i++) {
                let sub_headings = this.menu_items.filter(x=>x.parent_id == this.headings[i].id);
                this.headings[i].sub_headings = sub_headings;

                for (let j = 0; j < this.headings[i].sub_headings.length; j++) {
                    let items = this.menu_items.filter(x=>x.parent_id == this.headings[i].sub_headings[j].id);
                    this.headings[i].sub_headings[j].menu_items = items;
                }
            }
        },
        headerClick(type){
            if(type == 'login'){
                window.location.href = "https://commercialonlineorders.majestic.co.uk/";
            }
            if(type == 'new_customer'){
                this.$router.push('/how-does-it-work/new-customer');
            }
            if(type == 'contact'){
                this.$router.push('/how-does-it-work/contact-us');
            }
        },
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        logoutListener() {
            this.logged_in = false;
        },
        getScreenSize(){
            let navigation_header = document.getElementById('navigation_header')

            new ResizeObserver(()=>{
                clearTimeout(this.screen_size_check_timeout);

                this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                   
                    this.screen_width = navigation_header.clientWidth;
                  
                }, 1);
            }).observe(navigation_header);

        }
    },
    // beforeMount(){
    //     this.getMenuItems();
    // },
    created(){
        this.getMenuItems();
    },
    mounted(){
        this.getScreenSize();
    },
    // watch: {
    //     'logged_in_watcher': function() {
    //         this.logged_in = this.is_logged_in
    //     }
    // }
}
</script>

<style lang="scss" scoped>

.top-navigation-container{
    position: fixed; 
    width: 100%; 
    display: flex; 
    flex-direction: column; 
    z-index: 99;
}
.header-bar {
	// background-color: var(--primary-colour-2);
	background-color: white;
   // background-color: rgba( 256, 266, 256, 0.7);
    //backdrop-filter: blur(10px);
	color: var(--top-nav-bar-text-colour);
    height: var(--top-nav-bar-height);
    align-content: center;
    padding-left: 20px;
    justify-content: center;
    align-items: center;
    display: flex;

    @media(max-width: 1100px){
        padding-left: 0px;
    }
    // padding-right: 20px;
}

.nav-bar-items{
    color: black;
    display: flex;
    justify-content: space-between;
    font-size: 0.95rem;
    padding-left: 20px;
    padding-right: 20px;
    align-items: center;
    gap: 48px;
    max-width: 1667px;
    width: 100%;

    @media(max-width: 1400px){
        gap: 24px;
    }

    @media(max-width: 768px){
        gap: 0px;
    }
}

.right-container{
    display: flex;
    gap: 22px;
    align-items: center;
    justify-content: flex-end;

    @media(max-width: 1100px){
        gap: 20px;
        flex-grow: 1;
    }
}

.mobile-menu-container{
    display: none;

    @media(max-width: 1100px){
        display: block;
        margin-right: 10px;
    }
}

.header-button{
    padding: 12px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid gray;
    outline: none;
    cursor: pointer;

    @media(max-width: 1100px){
        display: none;
    }
}

.header-button.login{
    background-color: #184A2E;
    color: white;

}
.header-button-icon{
    margin-right: 4px;
}

.phone-icon{
    color: var(--maj-slate);
    cursor: pointer;
   // margin-right: 24px;
    
    // @media(min-width: 768px){
    //     display: none;
    // }
}
</style>